/**
 * @author SwathiDivya Bhavaraju
 * @email swathidivya.bhavaraju@ul.com
 * @create date 2021-05-04 12:41:52
 * @modify date 2021-05-04 12:41:52
 * @desc [description]
 */
import axios from 'axios';

/* /activity/tracker/account/info/ get api
* to get account details by accountid */
export async function getAccountDetails(accountId) {
  let data = '';
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/activity/tracker/account/info/${accountId}`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        data = response.data.data;
      }
    })
    .catch((err) => {
      console.log('get /account/info/ java api error', err); // eslint-disable-line no-console
    });
  return data;
}
/* /activity/tracker/account/info/ get api
* to get account details by accountid */
export async function getAccountHistoryInfo(accountId) {
  let data = '';
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/activity/tracker/account/update/history/${accountId}`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        data = response.data.data;
      }
    })
    .catch((err) => {
      console.log('get /account/history java api error', err); // eslint-disable-line no-console
    });
  return data;
}
/* account/update put api
* to update account name by accountid */
export async function updateAccountName(data) {
  let res = '';
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/activity/tracker/account/update`, data)
    .then((response) => {
      if (response.status === 200 && response.data) {
        res = response.data;
      }
    })
    .catch((err) => {
      console.log('get /account/update java api error', err); // eslint-disable-line no-console
    });
  return res;
}

/* account/contact put api
* to update contact details by accountid */
export async function updateContactDetails(data) {
  let res = '';
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/activity/tracker/account/update/contact/details`, data)
    .then((response) => {
      if (response.status === 200 && response.data) {
        res = response.data;
      }
    })
    .catch((err) => {
      console.log('get /account/contact/ java api error', err); // eslint-disable-line no-console
    });
  return res;
}
/* user/data post api
* to post account details by accountid */
export async function getAccountUsers(formData) {
  let data = '';
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/activity/tracker/user/data`, formData)
    .then((response) => {
      if (response.status === 200 && response.data) {
        data = response.data;
      }
    })
    .catch((err) => {
      console.log('get /user/data java api error', err); // eslint-disable-line no-console
    });
  return data;
}

/* /user/preference get api
* to get account details users preferences */
export async function getUsersTablePreferences() {
  let data = '';
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/activity/tracker/user/preference`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        data = response.data.data;
      }
    })
    .catch((err) => {
      console.log('get /user/preference java api error', err); // eslint-disable-line no-console
    });
  return data;
}

/* /user/preference put api
* to update account details users preferences */
export async function UpdateUsersTablePreferences(formData) {
  let data = '';
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/activity/tracker/user/preference`, formData)
    .then((response) => {
      if (response.status === 200 && response.data) {
        data = response.data.data;
      }
    })
    .catch((err) => {
      console.log('get /user/preference java api error', err); // eslint-disable-line no-console
    });
  return data;
}

/* /activity/tracker/plans/info/ get api
* to get account plan details by accountid */
export async function getAccountServices(accountId) {
  let data = '';
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/activity/tracker/plans/info/${accountId}`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        data = response.data;
      }
    })
    .catch((err) => {
      console.log('get /user/preference java api error', err); // eslint-disable-line no-console
    });
  return data;
}
/* /activity/tracker/user/data get api
* to get user data by user id */
export async function getUserById(userId) {
  let data = '';
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/activity/tracker/user/info/${userId}`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        data = response.data.data;
      }
    })
    .catch((err) => {
      console.log('get /user/data java api error', err); // eslint-disable-line no-console
    });
  return data;
}
